import { CancelTokenSource } from 'axios'
import { ENDPOINTS } from 'const/endpoints'
import _ from 'lodash'
import axios from 'services/axios'
import { IProgramDashboardParams } from './Dashboard.interface'
import { commonMessages } from 'utils/messages'
import { onCreateEndpointsWithClientid } from 'utils/common'

export function getDashboardCounts(
	clientId: string | undefined,
	program: string | undefined,
	params: Partial<IProgramDashboardParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get(ENDPOINTS.PROGRAM_MANAGER_DASHBOARD + '/' + clientId + '/' + program, {
		params: filteredParams,
	})

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

export function getDashboardSessionCounts(
	clientId: string | undefined,
	program: string | undefined,
	params?: Partial<IProgramDashboardParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get(
		ENDPOINTS.PROGRAM_MANAGER_DASHBOARD_SESSION + '/' + clientId + '/' + program,
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

export function getDashboardGoalsCounts(
	clientId: string | undefined,
	program: string | undefined,
	params?: Partial<IProgramDashboardParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get(
		ENDPOINTS.PROGRAM_MANAGER_DASHBOARD_GOALS + '/' + clientId + '/' + program,
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

// export function getAllPartners(params: Partial<IProgramsParams>, source?: CancelTokenSource) {
// 	const filteredParams = _.pickBy(params, _.identity)

// 	const promise = axios.get<IPagination<Partial<IFullProgram>>>(ENDPOINTS.ASSIGNEE, {
// 		params: filteredParams,
// 	})
// 	//@ts-ignore
// 	promise.cancel = () => {
// 		source?.cancel(commonMessages.queryCancelledMessage)
// 	}
// 	return promise
// }

export function getProgramPartnerList(totalLimit?: number, source?: CancelTokenSource) {
	const promise = axios.get(ENDPOINTS.PROGRAM_PARTNER)

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

export function getDashboardPrograms(
	clientId: string | undefined,
	program: string | undefined,
	params: any,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)

	const promise = axios.get(ENDPOINTS.DASHBOARD_PROGRAMS + '/' + clientId + '/' + program, {
		params: filteredParams,
	})

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

export function getStarPartners(
	clientId?: string | undefined,
	params?: any,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get(ENDPOINTS.STAR_PARTNERS + '/' + clientId + '/' + params?.program, {
		params: filteredParams,
	})

	//@ts-ignore
	// Add cancel method to the promise

	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

export function getMde(program: string | undefined, params: any, source?: CancelTokenSource) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get(onCreateEndpointsWithClientid(ENDPOINTS.GET_MDE) + '/' + program, {
		params: filteredParams,
	})

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

// Dashboard Partner List
export function getPartnerListing(
	source?: CancelTokenSource,
	clientId?: string | undefined,
	params?: Partial<IProgramDashboardParams>,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get(ENDPOINTS.GET_HEALTHCARE_PARTNERS + '/' + clientId, {
		params: filteredParams,
	})
	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

// Dashboard Program List
export function getProgramListing(
	source?: CancelTokenSource,
	clientId?: string | undefined,
	params?: Partial<IProgramDashboardParams>,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get(ENDPOINTS.PROGRAM_FILTER_LIST + '/' + clientId, {
		params: filteredParams,
	})
	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

export function getDemographicDetails(params: any, source?: CancelTokenSource) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get(onCreateEndpointsWithClientid(ENDPOINTS.GET_DEMOGRAPHIC_DETAILS), {
		params: filteredParams,
	})

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}
